import { render } from "./CompareQueueTable.vue?vue&type=template&id=c84e88a8"
import script from "./CompareQueueTable.vue?vue&type=script&lang=js"
export * from "./CompareQueueTable.vue?vue&type=script&lang=js"

import "./CompareQueueTable.vue?vue&type=style&index=0&id=c84e88a8&lang=css"
script.render = render

export default script